import axios from "axios";
import { apiUrls } from "../Common/api.config";

export const CustomNotificationService = {
    getAllUserGroups,
    // getAllPriority,
    saveNotification,
    getAllDraftNotification,
    getNotificationByStatus,
    getAllSentNotification,
    getCountOfNotification,
    deleteNotificationById,
    sendNotification,
    uploadSignatureImage,
    // getAllUserGroupsBySearch
    deleteSignatureImage,
    getAllSentNotificationFilterByDate
}

function getAllUserGroups() {
    return axios.get(apiUrls.getAllDeptUrl.URL).then(resp => resp.data);
}

// function getAllUserGroupsBySearch(searchName) {
//     let url = apiUrls.getAllUserGroupsBySearch.URL.replace("{searchName}", searchName);
//     return axios.get(url).then(resp => resp.data);
// }

// function getAllPriority() {
//     return axios.get(apiUrls.getAllPriority.URL).then(resp => resp.data);
// }

function getAllDraftNotification() {
    return axios.get(apiUrls.getAllDraftNotification.URL).then(resp => resp.data);
}
function getNotificationByStatus(param){
    //console.log("param inside customnotificaitionservice.js");
    //console.log(param);
    return axios.get(apiUrls.getNotificationByStatus.URL+"/"+ param).then(resp => resp.data);
}

function getAllSentNotificationFilterByDate(date1,date2){
    //console.log(date1);
    //console.log(date2);
    //alert("hi");
    return axios.get(apiUrls.getAllSentNotification.URL+"/"+ date1+"/"+date2).then(resp => resp.data);
}

function getAllSentNotification() {
    return axios.get(apiUrls.getAllSentNotification.URL).then(resp => resp.data);
}

function getCountOfNotification() {
    return axios.get(apiUrls.getCountOfNotification.URL).then(resp => resp.data);
}

function deleteNotificationById(request) {
    let url = apiUrls.deleteNotificationById.URL.replace("{notificationId}", request.id);
    return axios.delete(url).then(resp => resp.data);
}

function saveNotification(request) {
    if (request && request.id) {
        // let url = apiUrls.updateNotification.URL.replace("{notificationId}", request.id);
       
        return axios.put(apiUrls.updateNotification.URL, request).then(resp => resp.data);
    } else
        return axios.post(apiUrls.createNotification.URL, request).then(resp => resp.data);
}

function sendNotification(request, id, value) {
    if (value === "sendNow") {
        let url = apiUrls.sendNotification.URL.replace("{notificationId}", id);
        return axios.post(url, request).then(resp => resp.data);
    } else if (value === "sendLater") {
        let url = apiUrls.sendNotificationLater.URL.replace("{notificationId}", id);
        return axios.post(url, request).then(resp => resp.data);
    }
}

// function deleteNewsImage(id){
 
//     let url = apiUrls.deleteNewsImage.URL+"/"+id;
    
//     return axios.delete(url);
  
//   }

function uploadSignatureImage(formData,id){
   
    let url = apiUrls.uploadSignatureImage.URL +"/"+ id +"/notification";
            return axios.post(url, formData).then(resp => resp.data);
}

function deleteSignatureImage(id){
   
    let url = apiUrls.deleteSignatureImage.URL+"/"+id;
    
    return axios.delete(url);
}